<template>
	<div class="flex flex-col h-full">
		<div
			class="flex items-center justify-between px-6 py-5 border-b border-gray-200"
		>
			<h4 class="font-medium text-lg">
				{{ $t("account.greeting") }}, {{ getUser?.Account?.Name }}
			</h4>
			<button
				type="button"
				:aria-label="$t('Close')"
				class="text-gray-500 hover:text-gray-900"
				@click="$emit('close')"
			>
				<XMarkIcon class="h-6 w-6" />
			</button>
		</div>

		<nav class="flex-1 overflow-y-auto px-4 py-6">
			<ul class="space-y-1">
				<li v-for="link in accountLinks" :key="link.to">
					<NuxtLink
						:to="link.to"
						class="block px-3 py-2 text-sm font-medium text-gray-700"
						active-class="bg-graycustom"
						@click="$emit('close')"
					>
						{{ $t(link.titleKey) }}
					</NuxtLink>
				</li>
			</ul>

			<button
				type="button"
				class="mt-6 flex items-center border border-gray-300 shadow-sm py-2 px-4 hover:bg-gray-50"
				@click="handleLogout"
			>
				<ArrowRightOnRectangleIcon class="h-5 w-5 text-gray-500" />
				<span class="ml-2 text-gray-700 text-sm font-medium">
					{{ $t("account.logout") }}
				</span>
			</button>
		</nav>
	</div>
</template>

<script setup lang="ts">
import {
	XMarkIcon,
	ArrowRightOnRectangleIcon
} from "@heroicons/vue/24/outline";
import { storeToRefs } from "pinia";
import { ROUTES } from "~/utils/routes";

const emit = defineEmits<{ close: [] }>();

const { getUser } = storeToRefs(userStore());
const localePath = useLocalePath();
const router = useRouter();
const cartStore = useCartStore();
const { logOut } = useNorcePwa();

const accountLinks = computed(() => [
	{ titleKey: "account.account_overview", to: localePath(ROUTES.ACCOUNT.ROOT) },
	{ titleKey: "account.my_profile", to: localePath(ROUTES.ACCOUNT.PROFILE) },
	{ titleKey: "account.addresses", to: localePath(ROUTES.ACCOUNT.ADDRESS) },
	{
		titleKey: "account.payment_methods",
		to: localePath(ROUTES.ACCOUNT.PAYMENT)
	},
	{ titleKey: "account.orders", to: localePath(ROUTES.ACCOUNT.ORDER) }
]);

const handleLogout = async () => {
	await logOut();
	useWishlistStore().$reset();
	userStore().setUser(null);
	cartStore.$reset();
	emit("close");
	router.push(localePath("/"));
};
</script>
